import {toQueryString} from "../utils/URLUtils";

const apiEndPoint = "/bescheid";

export function getBescheidEndpoint(bescheidsId) {
    return apiEndPoint + "/" + bescheidsId;
}

export const postBescheidEndpoint = apiEndPoint + "/";

export const postBescheidsantragEndpoint = "/bescheidsantrag/";

export function putBescheidEndpoint(bescheidsId) {
    return apiEndPoint + "/" + bescheidsId;
}

export function putBescheidsantragEndpoint(bescheidsId) {
    return `/bescheidsantrag/${bescheidsId}/`;
}

export function deleteBescheidEndpoint(bescheidsId) {
    return `${apiEndPoint}/${bescheidsId}`;
}

export function deleteBescheidsAntragEndpoint(bescheidsId) {
    return `/bescheidsantrag/${bescheidsId}`;
}

export function getBescheidsDateienEndpoint(bescheidsId) {
    return apiEndPoint + "/" + bescheidsId + "/dateien/";
}

export function getBescheidsDateiUploadEndpoint(bescheidsId) {
    return apiEndPoint + "/" + bescheidsId + "/upload-file/";
}

export function postWiedervorlageForBescheidEndpoint(bescheidsId) {
    return apiEndPoint + "/" + bescheidsId + "/wiedervorlage/";
}

export function getWiedervorlageForBescheidEndpoint(bescheidsId) {
    return apiEndPoint + "/" + bescheidsId + "/wiedervorlage/";
}

export function getBescheidsAnforderungenEndpoint(bescheidsId, messstellenId) {
    return apiEndPoint + "/" + bescheidsId + "/anforderung?messstelle=" + messstellenId;
}

export function deleteMessstelleFromBescheidEndpoint(bescheidsId, messstellenId) {
    return apiEndPoint + "/" + bescheidsId + "/messstelle/" + messstellenId;
}

/**
 * Gibt den Endpoint zurück, über den über DigiWab die Wasserrechte eines Bescheids.
 * abgerufen werden können
 * @param bescheidsId die ID des Bescheids, für den die Wasserrechte abgerufen werden sollen
 * @returns {string}
 */
export function getWasserrechteEndpoint(bescheidsId) {
    return "/digiwab/" + bescheidsId;
}

export function getWasserrechtEndpoint(wasserrechtNr) {
    return "/digiwab/wasserrechtnr/" + wasserrechtNr;
}

export function getDigiWabUrlEndpoint() {
    return "/digiwab-url/";
}

export function getDigiWabPageEndpointByNr(wasserrechtNr) {
    return "/digiwab-page/" + wasserrechtNr;
}

export function getDownloadPDFEndpoint(entryId, dokId) {
    return "/digiwab-pdf/?entryId=" + entryId + "&dokId=" + dokId;
}

export function getDigiWabDokumentEndpointByPath(path) {
    return "/digiwab-page?" + path;
}

/**
 * Darf nur in refetch von useHttp verwendet werden, falls der date String sich ändert.
 * @param messstellenId
 * @param date "Bescheidsdatum des Änderungsbescheids"
 * @param excludeBescheidId ID des Änderungsbescheides von dem keine Anforderungen gefetched werden sollen
 * @returns {string}
 */
export function getAnforderungenAusTagesbescheid(messstellenId, date, excludeBescheidId) {
    return (
        "/messstelle/" +
        messstellenId +
        "/anforderung?" +
        toQueryString({
            datum: date ? new Date(date).toISOString() : date,
            excludeBescheid: excludeBescheidId,
        })
    );
}

export function patchBescheidsanforderungenEndpoint(bescheidsId, messstellenId) {
    return apiEndPoint + "/" + bescheidsId + "?messstelle=" + messstellenId;
}

export function postBescheidUebersichtExportEndpointConfiguration(selectedIds, exportType) {
    return {
        url: apiEndPoint + "/export/" + exportType,
        method: "POST",
        data: selectedIds,
        responseType: "blob",
    };
}

export function getSelectableVorbescheideEndpoint(betriebId, bescheidId, bescheidQualitaetId) {
    const bescheidIdParam = bescheidId ? bescheidId : "neu";
    const bescheidQualitaetParam = "bescheidQualitaet=" + bescheidQualitaetId
    return "/betrieb/" + betriebId + "/bescheid/vorbescheide?bescheidId=" + bescheidIdParam + "&" + bescheidQualitaetParam;
}

export function getSelectableMessstellenEndpoint(betriebId, bescheidQualitaetId) {
    return "/betrieb/" + betriebId + "/bescheid/messstellen?bescheidQualitaet=" + bescheidQualitaetId;
}
